// extracted by mini-css-extract-plugin
export default {"wrapper":"balanceinfo_wrapper__Uomc8","amount":"balanceinfo_amount__p-b5j","currency":"balanceinfo_currency__ta02m","description":"balanceinfo_description__lJyNn"};